export default __webpack_public_path__ + "static/media/groomsLogo.17c816de.png";